export enum Flipper {
  ordersOperationalDashboard = 'rt_orders_operational_dashboard',
  ordersOperationalDashboardRoulettleToggle = 'rt_ops_dashboard_offer_explainability',
}
